import { render, staticRenderFns } from "./frame02.vue?vue&type=template&id=cf8736fe&scoped=true&"
import script from "./frame02.vue?vue&type=script&lang=js&"
export * from "./frame02.vue?vue&type=script&lang=js&"
import style0 from "./frame02.vue?vue&type=style&index=0&id=cf8736fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8736fe",
  null
  
)

export default component.exports